import { useMutation } from '@apollo/client';
import { ToastType } from '@alefeducation/ui-elements-library-core';
import {
  RESET_PASSWORD,
  SendPasswordResetLinkResponse,
} from '../../apollo/queries/restPassword.queries';
import { injectAutoHideToastOfType } from '../../utils/Toast';
import { SOMETHING_WENT_WRONG_MESSAGE } from '../../utils/constants';

const useRestPassword = () => {
  const [resetPassword] = useMutation<SendPasswordResetLinkResponse>(
    RESET_PASSWORD,
    {
      onError: () => {
        injectAutoHideToastOfType(
          'edit-member-toast',
          SOMETHING_WENT_WRONG_MESSAGE,
          ToastType.ERROR,
        );
      },
      onCompleted: (data) => {
        if (data.sendPasswordResetLink) {
          injectAutoHideToastOfType(
            'edit-member-toast',
            data.sendPasswordResetLink.message,
            ToastType.SUCCESS,
          );
        }
      },
    },
  );

  const handleResetPassword = (email: string) => {
    resetPassword({ variables: { email } });
  };

  return { resetPassword: handleResetPassword };
};

export default useRestPassword;
